import {NgModule} from '@angular/core';
import {AccordionModule} from 'primeng/accordion';
import {TimelineModule} from 'primeng/timeline';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService, MessageService} from 'primeng/api';
import {MenuModule} from 'primeng/menu';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {DialogService, DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef} from 'primeng/dynamicdialog';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import {TabViewModule} from 'primeng/tabview';
import {FileUploadModule} from 'primeng/fileupload';
import {MultiSelectModule} from 'primeng/multiselect';
import {RadioButtonModule} from 'primeng/radiobutton';
import {TextareaModule} from 'primeng/textarea';
import {InputTextModule} from 'primeng/inputtext';
import {InputNumberModule} from 'primeng/inputnumber';
import {CheckboxModule} from 'primeng/checkbox';
import {ListboxModule} from 'primeng/listbox';
import { FieldsetModule } from 'primeng/fieldset';
import { PanelModule } from 'primeng/panel';
import { TreeModule } from 'primeng/tree';
import {ContextMenuModule} from 'primeng/contextmenu';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

@NgModule({
  imports: [
    AccordionModule,
    TimelineModule,
    ConfirmDialogModule,
    MenuModule,
    DynamicDialogModule,
    TableModule,
    ButtonModule,
    DialogModule,
    ToastModule,
    DropdownModule,
    TabViewModule,
    FileUploadModule,
    MultiSelectModule,
    RadioButtonModule,
    TextareaModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    ListboxModule,
    FieldsetModule,
    PanelModule,
    TreeModule,
    ContextMenuModule,
    ConfirmPopupModule
  ],
  exports: [
    AccordionModule,
    TimelineModule,
    ConfirmDialogModule,
    MenuModule,
    DynamicDialogModule,
    TableModule,
    ButtonModule,
    DialogModule,
    ToastModule,
    DropdownModule,
    TabViewModule,
    FileUploadModule,
    MultiSelectModule,
    RadioButtonModule,
    TextareaModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    ListboxModule,
    FieldsetModule,
    PanelModule,
    TreeModule,
    ContextMenuModule,
    ConfirmPopupModule
  ],
  providers: [
    ConfirmationService,
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
    MessageService
  ]
})
export class PrimengModule {}
